<template>
  <div ref="animation" :style="{ padding, width, height }"></div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { loadScript } from '@/utils/loadScript'

// import lottie from 'lottie-web'
import lottieFlow from '@/assets/lottieFlow.json'

const props = defineProps({
  width: {
    type: String,
    default: '50px'
  },
  height: {
    type: String,
    default: '50px'
  },
  padding: {
    type: String,
    default: '0px'
  },
  autoplay: {
    type: Boolean,
    default: true
  },
  loop: {
    type: Boolean,
    default: true
  }
})
const animation = ref(null)

onMounted(async () => {
  if (animation.value) {
    await loadScript('/lib/lottie.min.js', 'lottie')
    const lottie = (window as any).lottie
    lottie.loadAnimation({
      container: animation.value,
      renderer: 'svg',
      loop: props.loop,
      autoplay: props.autoplay,
      animationData: lottieFlow
    })
  }
})
</script>

<style scoped></style>
